export { Typography700 } from './Typography700';
